export enum DebounceEnum {
  DEFAULT = 200,
  MEDIUM = 400,
  HIGH = 500,
}
